import classNames from "classnames";

interface CoastZoneProps {
    coastHints: string[];
}

const CoastZone = ({ coastHints }: CoastZoneProps) => (
    <figure className={classNames("coastzone", coastHints)}>
        <a href="/pages/coastzone/">
            <img
                src="https://i.iheart.com/v3/re/new_assets/ecb29da8-0999-4ecb-921f-8c0570b1c9b3"
                alt="CoastZone banner"
                height="135"
                width="90"
            />
        </a>
        <figcaption className="coastzonedesc">
            <h1>CoastZone</h1>
            <a href="/pages/coastzone/">Sign up for our free CoastZone e-newsletter</a> to receive exclusive daily
            articles.
        </figcaption>
    </figure>
);

export default CoastZone;
